import React, { useContext, useEffect, useState } from 'react';
import {
    Language,
    useGetLanguagesQuery,
} from '../../../../services/organizations/organizations.service';
import { SafetyDataSheetSectionHeader } from '../../../../types/formulation';
import { useDispatch } from 'react-redux';
import { openModalConfirmBasicWithMessage } from '../../../../store/uiElements';
import TranslatableText from '../../../../components/i18n/TranslatableText';
import { SdsSectionHeadersFormDefs } from '../../../../constants/i18n/translations/termDefinitions/formulation';
import SettingsContext from '../../../../contexts/settings.context';
import { useGetTermSetQuery } from '../../../../services/i18n/i18n.service';
import { FORMULATION_DEFS } from '../../../../constants/i18n/translations/termSetDefinitions/formulation';
import { skipToken } from '@reduxjs/toolkit/query';

const useSafetyDataSheetSectionHeaderContainer = () => {
    const dispatch = useDispatch();
    const [defaultLangId, setDefaultLangId] = useState(null as bigint);
    const [
        safetyDataSheetSectionHeaderKeyList,
        setSafetyDataSheetHeaderKeyList,
    ] = useState(null as Array<string>);
    const [isFormDirty, setIsFormDirty] = useState(false);

    const { data: languagesList, isLoading: isLoadingLanguages } =
        useGetLanguagesQuery();

    const { settings } = useContext(SettingsContext);
    const { data: termSet } = useGetTermSetQuery(
        settings?.userSettings
            ? {
                  languageId: settings?.userSettings?.languageId,
                  code: FORMULATION_DEFS.SDS_SECTION_HEADERS_GRID,
              }
            : skipToken
    );

    const { data: formTermSet } = useGetTermSetQuery(
        settings?.userSettings
            ? {
                  languageId: settings?.userSettings?.languageId,
                  code: FORMULATION_DEFS.SDS_SECTION_HEADERS_FORM,
              }
            : skipToken
    );

    useEffect(() => {
        if (languagesList && !defaultLangId) {
            const defaultLangId = languagesList?.find(
                (lang: Language) => lang.code === 'ENG'
            )?.id;
            setDefaultLangId(defaultLangId);
        }
    }, [languagesList]);

    const handleSetHeaderKeyList = (
        headerList: Array<SafetyDataSheetSectionHeader>
    ): void => {
        const list = headerList?.map((current) => current.headerIdLocaleGrpId);
        setSafetyDataSheetHeaderKeyList(list);
    };

    const handleSetIsFormDirty = (formDirty: boolean) => {
        if (formDirty !== isFormDirty) {
            setIsFormDirty(formDirty);
        }
    };

    const handlePromptFormDirty = (
        onConfirm: () => void,
        onCancel?: () => void
    ) => {
        if (isFormDirty) {
            const message = (
                <TranslatableText
                    termSet={formTermSet}
                    termKey={SdsSectionHeadersFormDefs.Changes_Not_Saved}
                />
            );
            dispatch(
                openModalConfirmBasicWithMessage({
                    message: message,
                    title: '',
                    onConfirm: () => {
                        handleSetIsFormDirty(false);
                        onConfirm();
                    },
                    onCancel: onCancel,
                })
            );
        } else {
            onConfirm();
        }
    };

    return {
        languagesList,
        defaultLangId,
        isLoadingLanguages,
        safetyDataSheetSectionHeaderKeyList,
        handleSetHeaderKeyList,
        handleSetIsFormDirty,
        handlePromptFormDirty,
        termSet,
    };
};

export default useSafetyDataSheetSectionHeaderContainer;
